import React from 'react';

import type { PromotedEntities, TournamentsMenuLayerItem } from '../../types';

import { TournamentsMenuItem } from './TournamentsMenuItem';

import styles from './TournamentsMenu.module.scss';

type TournamentsMenuItemsProps = {
  list: TournamentsMenuLayerItem[];
  promotedEntities: PromotedEntities;
};

export const TournamentsMenuItems: React.FC<TournamentsMenuItemsProps> = ({
  list,
  promotedEntities,
}) => {
  return (
    <ul className={styles.list}>
      {list.map((item) => {
        return (
          <TournamentsMenuItem entry={item}
                               promotedEntities={promotedEntities}
                               key={item.key} />
        );
      })}
    </ul>
  );
};
